import React, { useContext } from "react"
import { Link } from "gatsby"
import ContactComponent from "../Contact/ContactComponent"
// import Link from "../link"
import {LinkedInIcon} from "../icons/linkedin-icon"
import {TwitterIcon} from "../icons/twitter-icon"
import {GithubIcon} from "../icons/github-icon"
import {BuymeacoffeeIcon} from "../icons/buymeacoffee-icon"
import {Signature} from "../icons/signature"
import config from "../../../config/website"
import { ThemeContext } from "../../context/themeContext"

const siteMapUrl = `${config.siteUrl}/sitemap/sitemap-0.xml`

const LINKS = [
  { name: "About", to: "/about", label: "View about page" },
  { name: "Project", to: "/project", label: "View project page" },
  { name: "Blog", to: "/blog", label: "View blog page" },
  { name: "Contact", to: "/contact", label: "View contact page" },
  { name: "Sitemap.xml", to: siteMapUrl, label: "View sitemap.xml" },
]

const NavLink = ({ to, label, ...rest }) => {
  return (
    <li className="my-4">
      <Link
        to={to}
        aria-label={label}
        activeClassName=""
        className="font-normal text-xl lg:text-2xl text-secondary-text text-start whitespace-nowrap border-b-2 border-transparent hover:border-current hover:text-quarternary dark:hover:border-quarternary cursor-pointer select-none"
        {...rest}
      />
        
    </li>
  )
}

const Footer = ({author}) => {
  const { theme, setTheme } = useContext(ThemeContext)
  return (
    <footer className="border-t-2 border-tertiary mt-72">
      <div className="relative">
        <ContactComponent />
      </div>
      <div className="container mx-auto py-52 mt-12">
        
        <div className="grid grid-cols-2 gap-x-8 lg:gap-6 place-content-stretch">
          <div className="w-full lg:w-2/3 pl-2 mx-auto">
            <h1 className="font-body2 font-medium text-2xl lg:text-4xl text-quarternary text-start">{author}</h1>
            <h2 className="font-normal text-xl lg:text-3xl text-secondary-text text-start my-6">
              Living, learning, & leveling up one day at a time.
            </h2>
            <div className="flex flex-row space-x-4  w-9/12 lg:w-full">
              <a href={config.linkedin} rel="noreferrer noopener" target="_blank" alt={config.linkedin} className="text-quarternary hover:text-blue-500">
                <LinkedInIcon size={36} />
              </a>
              <a href={config.twitter} rel="noreferrer noopener" target="_blank" alt={config.linkedin} className="text-quarternary hover:text-sky-400">
                <TwitterIcon size={36} />
              </a>
              <a href={config.github} rel="noreferrer noopener" target="_blank" alt={config.linkedin} className="text-quarternary hover:text-stone-500">
                <GithubIcon size={36} />
              </a>
              <a href={config.buymeacoffee} rel="noreferrer noopener" target="_blank" alt={config.linkedin} className="text-quarternary hover:text-yellow-300">
                <BuymeacoffeeIcon size={36}/>
              </a>
            </div>
            <div className="w-1/2 md:w-1/3 lg:w-1/3 mt-12 ml-2 lg:ml-0">
              <Link to="/" aria-label="go back home" className="text-quarternary">
                <Signature size={200} title={author} />
              </Link>
            </div>
          </div>
          <div className="flex flex-col mx-auto">
            <h3 className="font-body2 font-medium text-xl lg:text-2xl text-quarternary text-start">Sitemap</h3>
            <ul className="">
              {LINKS.map(link => (
                <NavLink key={link.to} to={link.to} label={link.label}>
                  {link.name}
                </NavLink>
              ))}
            </ul>
          </div>
        </div>


      </div>
      <div className="flex items-center text-center justify-center tracking-wider py-8">
        <Link to="/" aria-label="home-nav">
          <p className="text-sm md:text-md lg:text-lg font-normal text-transparent bg-clip-text bg-gradient-to-br from-blue-200 via-blue-400 to-purple-900 dark:from-gray-600 dark:via-gray-400 dark:to-white mb-2">
            &copy; 2021 All Rights Reserved | Danniel Hansel
            {/* <span className="text-blue-400">Danniel Hansel &copy; 2021</span> */}
          </p>
          <p className="text-sm md:text-md lg:text-lg font-normal text-transparent bg-clip-text bg-gradient-to-br from-blue-200 via-blue-400 to-purple-900 dark:from-gray-600 dark:via-gray-400 dark:to-white ">
            Designed & Built with ❤️ in Dallas, TX
          </p>
        </Link>
        {/* Social Links Here */}
      </div>
    </footer>
  )
}
export default Footer
